import { render, staticRenderFns } from "./GoogleDashboard.vue?vue&type=template&id=f2edef20&scoped=true"
import script from "./GoogleDashboard.vue?vue&type=script&lang=js"
export * from "./GoogleDashboard.vue?vue&type=script&lang=js"
import style0 from "./GoogleDashboard.vue?vue&type=style&index=0&id=f2edef20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2edef20",
  null
  
)

export default component.exports